import {AdvancedAnalysisFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';

export const ADVANCED_ANALYSIS_ACCESS_MESSAGE =
  'To access this feature, please contact your account manager or support@benchling.com.';

export function isRegressionsEnabled(): boolean {
  return isFeatureEnabled({feature: AdvancedAnalysisFeature.ADVANCED_ANALYSIS_CREATE_STATISTICS});
}

export function isAnalysisTemplatesEnabled(): boolean {
  return isFeatureEnabled({feature: AdvancedAnalysisFeature.ADVANCED_ANALYSIS_CREATE_TEMPLATES});
}

export function isAnalysisToolBoxPlotEnabled(): boolean {
  return BenchlingConfig.ENABLE_INSIGHTS_LABS;
}

export function isExperimentOptimizationEnabled(): boolean {
  return (
    BenchlingConfig.ENABLE_INSIGHTS_LABS &&
    isFeatureEnabled({feature: AdvancedAnalysisFeature.ADVANCED_ANALYSIS_CREATE_STATISTICS})
  );
}
